/*
 *		Copyright (c) 2011-2023 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('accessWebClient')
    .controller('ShareGroupsMembersModalController', [
        '$modalInstance',
        '$scope',
        '$timeout',
        '$translate',
        'flashMessagesService',
        'ShareGroupsAddMembersModal',
        'shareGroup',
        'ShareGroupsMembersResource',
        function (
            $modalInstance,
            $scope,
            $timeout,
            $translate,
            flashMessagesService,
            ShareGroupsAddMembersModal,
            shareGroup,
            ShareGroupsMembersResource
        ) {
            let hasGroupChanged = false;
            $scope.removingMemberIndex;
            $scope.modal = $modalInstance.options;
            $scope.close = $scope.cancel = () => hasGroupChanged ? $modalInstance.close() : $modalInstance.dismiss();

            Object.defineProperties($scope, {
                userCanAddMembers: {
                    get: () => shareGroup.isCurrentUserGroupOwner
                }
            });

            $scope.showAddMembersDialog = () => ShareGroupsAddMembersModal(shareGroup)
                .then(() => {
                    $timeout(() => flashMessagesService.add(
                        $translate.instant('share_groups_add_members_success_flash_message'),
                        flashMessagesService.SUCCESS,
                        null,
                        true
                    ));
                    _fetchMembers();
                    hasGroupChanged = true;
                });

            $scope.removeMember = (memberIndex) => {
                $scope.removingMemberIndex = memberIndex;

                ShareGroupsMembersResource.delete({
                    share_group_id: shareGroup.uuid,
                    id: $scope.members[memberIndex].uuid
                }).$promise
                    .then(() => {
                        flashMessagesService.add(
                            $translate.instant('share_groups_members_modal_remove_member_success_message'),
                            flashMessagesService.SUCCESS,
                            null,
                            true
                        );
                        $scope.members.splice(memberIndex, 1);
                        hasGroupChanged = true;
                    })
                    .catch(() => flashMessagesService.add(
                        $translate.instant('share_groups_members_modal_remove_member_fail_message'),
                        flashMessagesService.ERROR
                    ))
                    .finally(() => $scope.removingMemberIndex = null);
            };

            _fetchMembers();

            function _fetchMembers() {
                $scope.modal.loading = true;

                ShareGroupsMembersResource.query({ share_group_id: shareGroup.uuid }).$promise
                    .then((members) => $scope.members = members)
                    .finally(() => $scope.modal.loading = false);
            };
        }
    ]);
